import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import Hero from './components/Hero';
import FeaturedArticles from './components/FeaturedArticles';
import Categories from './components/Categories';
import FAQ from './components/FAQ';
import CTASubscribe from './components/CTASubscribe';

export default function Home() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const websiteSchema = {
    name: t('common.siteTitle'),
    url: 'https://family-relationships-guide.com',
    description: t('home.heroDescription'),
    inLanguage: 'zh-CN',
  };

  const faqSchema = {
    mainEntity: [
      { '@type': 'Question', name: '继母应该如何与青春期的继子女建立关系？', acceptedAnswer: { '@type': 'Answer', text: '与青春期继子女建立关系，关键是保持耐心和一致性。不要急于求成，从日常小事入手——尊重他们的空间、在需要时提供支持但不强迫介入、通过间接沟通如短信和共同活动来建立连接。' } },
      { '@type': 'Question', name: '继姐之间的竞争和嫉妒该如何处理？', acceptedAnswer: { '@type': 'Answer', text: '首先要认识到竞争和嫉妒是正常的情绪反应。可以通过坦诚沟通感受、寻找共同兴趣、父母公平对待、建立独属仪式等方式来化解。' } },
      { '@type': 'Question', name: '重组家庭需要多长时间才能真正融合？', acceptedAnswer: { '@type': 'Answer', text: '研究显示重组家庭完全融合平均需要2到5年时间。第一年建立基本规则，第二到三年深度磨合，三到五年后找到稳定相处模式。每个家庭情况不同，重要的是保持耐心和持续努力。' } },
      { '@type': 'Question', name: '如何在重组家庭中保护好夫妻关系？', acceptedAnswer: { '@type': 'Answer', text: '夫妻关系是重组家庭的基石。建议每周保证夫妻独处时间、在子女面前呈现统一教养阵线、定期进行关系状态沟通、不要让子女问题占据全部生活空间、必要时寻求专业帮助。' } },
      { '@type': 'Question', name: '继母在家庭中应该扮演什么样的管教角色？', acceptedAnswer: { '@type': 'Answer', text: '初期建议以支持者而非管教者身份出现。让生物学父母主导重大纪律决策，继母专注于建立情感连接。随着信任建立，逐步承担更多共同管教责任，这个过程通常需要一年以上。' } },
    ],
  };

  return (
    <>
      <SchemaOrg type="WebSite" data={websiteSchema} />
      <SchemaOrg type="FAQPage" data={faqSchema} />
      <Navbar />
      <main>
        <Hero />
        <FeaturedArticles />
        <Categories />
        <FAQ />
        <CTASubscribe />
      </main>
      <Footer />
    </>
  );
}